// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cardsContainerClinical .url-title{
  color:red
}

.oncokb-icon-styling{
  font-size:30px !important
}

.tabs{
  display:flex;
  border-bottom:2px solid #ddd;
  width:70%
}

.tabs button{
  flex:1;
  padding:10px 20px;
  cursor:pointer;
  background-color:#fff;
  color:#373a3c !important;
  border:1px solid #ddd;
  border-bottom:none;
  outline:none;
  margin-right:-1px
}

.tabs button:last-child{
  margin-right:0
}

.tabs button.active{
  background-color:#2ca591;
  border-bottom:2px solid #fff;
  color:#fff !important;
  font-weight:bold;
  border-color:#d4d4d8 !important
}

.tab-content{
  padding:20px;
  background-color:#fff;
  border:1px solid #ddd;
  border-top:none
}

.oncokb_table{
  width:80%;
  border-collapse:collapse;
  margin-top:20px
}

.oncokb_table th,.oncokb_table td{
  border:1px solid #d4d4d8;
  padding:8px;
  text-align:left
}

.oncokb_table th{
  background-color:#f0f0f0
}

.oncoKB-tooltip{
  position:relative;
  display:inline-block;
  cursor:pointer
}

.oncoKB-tooltip-text{
  visibility:hidden;
  width:140px;
  background-color:#000;
  color:#fff;
  text-align:center;
  border-radius:4px;
  padding:5px;
  position:absolute;
  z-index:1;
  bottom:125%;
  left:50%;
  transform:translateX(-50%);
  opacity:0;
  transition:opacity .3s
}

.oncoKB-tooltip:hover .oncoKB-tooltip-text{
  visibility:visible !important;
  opacity:1 !important
}`, "",{"version":3,"sources":["webpack://./src/js/pages/variant/components/OncoKB/oncoKB.scss"],"names":[],"mappings":"AAEE;EACE;AAAA;;AAIJ;EACE;AAAA;;AAIF;EACE,YAAA;EACA,4BAAA;EACA;AAAA;;AAGF;EACE,MAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA;AAAA;;AAGF;EACE,YAAA;EACA,qBAAA;EACA,qBAAA;EACA;AAAA;;AAIF;EACE,SAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE,wBAAA;EACA,WAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAIF;EACE,iBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,0BAAA;EACA,SAAA;EACA;AAAA;;AAGF;EACE,6BAAA;EACA;AAAA","sourcesContent":["\n#cardsContainerClinical {\n  .url-title {\n    color: red;\n  }\n}\n\n.oncokb-icon-styling{\n  font-size: 30px !important;\n}\n\n//4 tabs section\n.tabs {\n  display: flex; \n  border-bottom: 2px solid #ddd; \n  width: 70%;\n}\n\n.tabs button {\n  flex: 1;\n  padding: 10px 20px;\n  cursor: pointer;\n  background-color: #fff;\n  color: #373a3c !important;\n  border: 1px solid #ddd;\n  border-bottom: none; \n  outline: none;\n  margin-right: -1px;\n}\n\n.tabs button:last-child {\n  margin-right: 0;\n}\n\n.tabs button.active {\n  background-color: #2CA591;\n  border-bottom: 2px solid white; \n  color: #fff !important;\n  font-weight: bold;\n  border-color: #d4d4d8 !important;\n}\n\n.tab-content {\n  padding: 20px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-top: none;\n}\n\n// OncoKB table\n.oncokb_table {\n  width: 80%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.oncokb_table th, .oncokb_table td {\n  border: 1px solid #d4d4d8;\n  padding: 8px;\n  text-align: left;\n}\n\n.oncokb_table th {\n  background-color: #f0f0f0;\n}\n\n// card tooltip\n.oncoKB-tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.oncoKB-tooltip-text {\n  visibility: hidden;\n  width: 140px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 4px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.oncoKB-tooltip:hover .oncoKB-tooltip-text {\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
